
import React from "react";
import Link from "next/link";
import Image from "next/image";

interface FeaturedTopProps {
  blok?: any;
}

const FeaturedTop: React.FC<FeaturedTopProps> = ({ blok }) => {
  if (!blok) return null;

  const {
    title,
    description,
    thumb,
    topics,
    slug,
    author_name,
    author_photo,
  } = blok || {};

  const blogUrl = `/blog/${slug}`;

  const plainDescription = description?.content?.[0]?.content?.[0]?.text || description;

  return (
    <Link href={blogUrl} className="blog-preview blog-preview-featured card card-lighter scroll-trigger text-dark"
          data-filter={title}>
      <div
        className="blog-preview-image js-lazy-load"
        data-background-image={thumb || ""}
        style={{ backgroundImage: `url("${thumb || ""}")` }}
      >
        {topics && (
          <span className="blog-preview-tag d-md-none">{topics}</span>
        )}
      </div>
      <div className="blog-preview-content p-3 p-lg-4">
        {topics && (
          <div className="mb-4 d-none d-md-block">
            <span className="blog-preview-tag">{topics}</span>
          </div>
        )}
        <h3 className="title blog-preview-text mb-3">{title}</h3>
        <p className="blog-preview-description mb-3">{plainDescription}</p>
        <p className="blog-preview-note mb-4">
          <Image
            src={author_photo}
            width={30}
            height={30}
            alt={author_name || ""}
            className="rounded-circle me-1"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="lazy"
            quality={75}
          />
          {author_name}
        </p>
        <p className="blog-preview-link mb-0">
          <span className="btn btn-lg btn-primary">Read More</span>
        </p>
      </div>
    </Link>
  );
};

export default FeaturedTop;